module.exports = __webpack_public_path__ + "im.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/im.svg
// module id = 864
// module chunks = 0